import { Stack, Switch, Typography, useTheme } from "@mui/material";
import React from "react";

export default function SwitchButton({
  showActiveProducts,
  activePr,
  handleQuery,
}) {
  const theme = useTheme();
  return (
    <Stack sx={{ width: "100%" }}>
      <Typography
        component={"h1"}
        variant="h6"
        sx={{
          color: theme.palette.primary.main,
          fontWeight: "bold",
          textAlign: "center",
          mb:"1rem" ,
          display:{xs:"none" , lg:"flex"}
        }}
      >
        محصولات نی موبایل
      </Typography>
      <Stack
        direction={"row"}
        sx={{
          width: { xs: "200px", lg: "100%" },
          justifyContent: "space-between",
          alignItems: "center",
          mb: "0rem",
          gap: ".5rem",
          py: { xs: ".7rem", lg: "" },
          // width:"100%"
        }}
      >
        <Typography
          sx={{
            fontSize: { xs: ".9rem", lg: "1.1rem" },
            fontWeight: "600",
            whiteSpace: "nowrap",
          }}
        >
          نمایش کالاهای موجود
        </Typography>
        <Switch
          label={null}
          checked={activePr}
          onClick={() => showActiveProducts()}
          sx={{
            width: 70,
            height: 26,
            padding: 0,

            "& .MuiSwitch-switchBase": {
              padding: 0,
              top: "50%",
              left: "4px",
              transform: "translateY(-50%)",
              "&.Mui-checked": {
                transform: "translateX(44px) translateY(-50%)",
                color: theme.palette.background.default,
                "& + .MuiSwitch-track": {
                  backgroundColor: theme.palette.primary.main,
                  opacity: 0.9,
                },
              },
            },
            "& .MuiSwitch-thumb": {
              width: 20,
              height: 20,
              backgroundColor: !activePr ? theme.palette.primary.main : theme.palette.background.default,
            },
            "& .MuiSwitch-track": {
              borderRadius: 36 / 2,
              backgroundColor: theme.palette.background.default,
              border: activePr ? "" : `1px solid ${theme.palette.primary.main}`,
              opacity: 1,
            },
          }}
        />
      </Stack>
    </Stack>
  );
}
